import { Component } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { FormService } from 'src/app/form/form.service';
import { FormSend, FormTable } from 'src/app/form/model/form.model';
import { NotificationService } from 'src/app/notifications/notification.service';
import { TableColumnService } from 'src/app/table-column/table-column.service';
import { TableAttributeModel } from 'src/app/utils/component/table/model/table.model';
import { form_columns_description } from 'src/app/utils/const/table/form.const';
import { sortTableByAttribute } from 'src/app/utils/function/table-sort-helper.util';
import { FileEntryPopupData } from 'src/app/utils/popup/file-entry-popup/model/file-entry-popup.model';
import { downloadFile } from '../../../utils/function/file-helper.util';

@Component({
  selector: 'app-organisation-form-management',
  templateUrl: './organisation-form-management.component.html',
  styleUrl: './organisation-form-management.component.scss',
  standalone: false
})
export class OrganisationFormManagementComponent {

    objectList: FormTable[] = []
    filteredList: FormTable[] = [];
    displayList: FormTable[] = [];


    searchBar: FormControl = new FormControl('');

    constructor(
      private formService: FormService,
      private router: Router,
      public fb: FormBuilder,
      private notificationService: NotificationService,
      private tableColumnService: TableColumnService
    ) {}

    ngOnInit(){
      this.initializeForm();
      this.initializeOnChange();
      this.initializeTable();
    }


    createUser($event:FormTable){
      this.objectList.push($event);
    }



    initializeForm(){
      this.formService.getTableFormList().subscribe(value => {
        this.objectList = value;
        this.filteredList = this.objectList;
        this.displayList = this.objectList;
      });
    }


    initializeOnChange(){
      this.searchBar.valueChanges.subscribe((value: string) => {
        this.onSearchChange(value);
      });
    }

    onSearchChange(searchTerm: string): void {
      const term = searchTerm.toLowerCase().trim();
      //Avoid searching on undefined terms
      const safeToLower = (val: string) => (val ? val.toLowerCase() : '')

      this.filteredList = this.objectList.filter(item =>
        safeToLower(item.name).includes(term) ||
        safeToLower(item.formID).includes(term)
      );
    }


    columnSortTracker: number[]=[]
    tableColumnList: TableAttributeModel[] = [];
    availableColumnList: TableAttributeModel[] = [];

    initializeTable(){
      /*
      this.tableColumnService.getTableColumns(TableName.TEAM_ORG).subscribe((columns) => {
        //User has modified and saved columns

        if (columns.length !== 0){
          const columnsSet = new Set(columns.map(c => c.columnName));

          this.tableColumnList = team_columns_description.filter(desc => columnsSet.has(desc.name));
          this.availableColumnList = team_columns_description.filter(desc => !columnsSet.has(desc.name));
        }else{
            this.tableColumnList = team_columns_description.filter(desc => desc.initial);
            this.availableColumnList = team_columns_description.filter(desc => !desc.initial);
        }

        this.columnSortTracker = new Array(this.tableColumnList.length).fill(0);
      });
      */

      this.tableColumnList = form_columns_description.filter(desc => desc.initial);
      this.availableColumnList = form_columns_description.filter(desc => !desc.initial);
      this.columnSortTracker = new Array(this.tableColumnList.length).fill(0);
    }




    columnSortModification(indexColumn: number, indexSort: number, attribute: string){
      // Reset all columns to 0
      this.columnSortTracker = this.columnSortTracker.map(() => 0);

      // Set the selected column’s sort state
      this.columnSortTracker[indexColumn] = indexSort;

      this.displayList = sortTableByAttribute<FormTable>(this.filteredList,attribute as keyof FormTable,indexSort);
    }


    getValueOfRowAttribute(repository: FormTable, columnName: string): any {
      return repository[columnName as keyof FormTable];
    }



    //DOWNLOAD FORM FILE
    downloadFormFile(index: number){
      this.formService.downloadFileForm(this.displayList[index].uuid).subscribe((data: Blob) => {

        const blob = new Blob([data], { type: 'application/pdf' });
        downloadFile(blob, 'form.pdf');

      })
    }



    //ADD TEAM POPUP
    addStatePopup:boolean=false;

    addStatePopupClose($event: boolean){
      this.addStatePopup=false;
    }

    addStatePopupOpen(){
      this.addStatePopup=true;
    }

    addForm($event : FormTable){
      this.objectList.push($event);
    }



    //REMOVE TEAM POPUP
    removeStatePopup:boolean=false;
    deleteObject?:FormTable;

    removeStatePopupClose($event: string){
      if ($event != ''){
        const indexObject = this.objectList.findIndex(obj => obj.uuid === $event);
        this.objectList.splice(indexObject, 1);
      }
      this.deleteObject = undefined;
      this.removeStatePopup=false;
    }

    removeStatePopupOpen(index: number){
      this.deleteObject=this.displayList[index];
      this.removeStatePopup=true;
    }



    //EDIT TEAM POPUP
    editStatePopup:boolean=false;
    editObject?:FormTable;
    editUUID:string='';

    editStatePopupClose($event: boolean){
      this.editObject=undefined;
      this.editStatePopup=false;
      this.editUUID ='';
    }

    editStatePopupOpen(index: number){
      this.editObject = this.displayList[index];
      this.editUUID = this.displayList[index].uuid;
      this.editStatePopup=true;
    }

    editForm(editTable : FormSend){
      const indexObject = this.objectList.findIndex(obj => obj.uuid === editTable.uuid);

      //Update informations
      this.objectList[indexObject].formID = editTable.formID;
      this.objectList[indexObject].name = editTable.name;
      this.objectList[indexObject].category = editTable.category;

    }



}
